var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourthVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 689,
    height: 672,
    viewBox: "0 0 689 672",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.003 32.8855C380.086 1.96781 460.539 -8.7883 525.536 9.3937C588.44 26.9903 617.917 82.982 654.855 128.234C684.716 164.817 695.286 209.259 720.685 248.47C753.16 298.603 818.278 332.068 825.275 391.32C832.972 456.491 823.449 539.344 760.617 586.59C695.886 635.264 660.973 511.204 580.5 510.5C522.086 509.989 418.818 576.972 359.8 583.085C272.52 592.127 174.92 704.236 109.781 662.737C46.1519 622.201 170.917 516.725 150.171 449.535C130.522 385.9 -4.72211 378.7 0.967285 310.334C6.24845 246.873 117.911 223.189 173.076 174.295C224.31 128.886 249.869 62.891 314.003 32.8855Z",
    fill: "#28CC9E",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthVector);
export default __webpack_public_path__ + "static/media/FourthVector.acf21d2284bd2143414bccbfd9725a9d.svg";
export { ForwardRef as ReactComponent };